import { ActiveStateStrategy, NavigationItemBase } from "@/domains/navigation/navigation-item"

import type { Location } from "../navigation-item"

export class ActiveStateExactMatchStrategy implements ActiveStateStrategy {
  isActive(location: Location, item: NavigationItemBase): boolean {
    return location.pathname === item.href
  }
}
